import AuthModal from './auth/authModalComponent';
import FiltersModal from './filters';
import ChangeLogoModal from './changeLogo';
import ChangePassModal from './changePass';
import ResetPassModal from './resetPass';

export { AuthModal, FiltersModal, ChangeLogoModal, ChangePassModal, ResetPassModal }
